<section class="mt-5">
    <div class="container text-center text-lg-start">
      <img class="content-points" src="assets/icons/element-graphique-point.svg" />
      <div class="row content">
        <div class="col-lg-8">
          <div class="row-bootstrap">
            <div class="col-lg-4 partner my-3"  *ngFor="let partner of crConseils">
                <img class="img-fluid"  src="{{ partner.vignette}}"  />
                <div class="mt-3 bib-titre">
                  <p class="text-dark mb-2"><strong>{{ partner.titre }}</strong></p>
                  <div class="divider mb-2"></div>
                  <button class="btn btn-dark"><a href="{{partner.file}}" target="_blank">TELECHARGER</a></button>
                </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <app-quick-access></app-quick-access>
        </div>
      </div>
    </div>
</section>
